import { Component, OnInit, ViewChild, HostListener, ElementRef, OnDestroy } from '@angular/core';
import { AddressSearch } from '../models/addresssearch';
import { Customer } from '../models/customer';
import { MatTableDataSource } from '@angular/material/table';
import { Sort } from '@angular/material/sort';
import { UtilityService } from '../services/utility.service';
import { MatTabGroup, MatTabChangeEvent } from '@angular/material/tabs';
import { CustomerService } from '../services/customer.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { WaitDialogComponent } from '../util/wait-dialog/wait-dialog.component';
import { DataTransferService } from '../services/data-transfer.service';
import Swal from 'sweetalert2';
import { WorkorderService } from '../services/workorder.service';
import { Workorder } from '../models/workorder';
import { EnrollmentService } from '../services/enrollment.service';
import { LocationsearchService } from '../services/locationsearch.service';
import { MatPaginator } from '@angular/material/paginator';
import { SharedData, UserService } from '../services/user.service';
import { PastParticipationDialogComponent } from '../util/past-participation-dialog/past-participation-dialog.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { RetainformdataService } from '../retainformdata.service';

@Component({
    selector: 'app-customer-search',
    templateUrl: './customer-search.component.html',
    styleUrls: ['./customer-search.component.scss']
})
export class CustomerSearchComponent implements OnInit, OnDestroy {
    @ViewChild(MatPaginator, { static: false })
    set paginator(value: MatPaginator) {
        if (this.dataSource.filteredData.length != 0) {
            this.dataSource.paginator = value;
            console.log('datasoure:', this.dataSource);
        }
        if (this.dataSource1.filteredData.length != 0) {
            console.log('datasoure1:', this.dataSource1);
            this.dataSource1.paginator = value;
        }
    };
    className: any;
    phoneNumber: any;
    email = '';
    premiseId = '';
    checkNumber = '';
    serialno: any;
    utilcode = '';
    statusData: any;
    addressCriteria: AddressSearch;
    accountNumber: any;
    customers: any;
    workorders: any;
    serialnumbers: any;
    searching = false;
    workorderSearching = false;
    displaySearch = true;
    displayResult = false;
    displayWorkorder = false;
    displaySerial = false;
    displayCheckNumber = false;
    displayedColumns: string[] = ['name', 'account', 'phone', 'email', 'address', 'zip', 'providerName', 'premiseid', 'externalid','checknumber'];
    displayedColumns1: string[] = ['name', 'program', 'status', 'customer', 'statusDate', 'address', 'city', 'externalKey', 'premiseid', 'externalid', 'buttonSchedule'];
    displayedColumns2: string[] = ['name', 'program', 'status', 'customer', 'statusDate', 'address', 'city', 'serialno', 'externalKey', 'premiseid', 'externalid', 'buttonSchedule'];
    displayedColumns3: string[] = ['check', 'customer', 'payee', 'workorderid', 'description'];
    dataSource1 = new MatTableDataSource<Workorder>();
    dataSource = new MatTableDataSource<Customer>();
    programList: Programs[] = [];
    selectedProgram: Programs;
    statusList: Status[];
    selectedStatus: Status;
    contractors: Contractors[];
    selectedContractor: Contractors | null = null;
    noDataEntered: boolean = false;
    showWorkorderSearch = true;
    workorderName: any;
    startDate: Date;
    endDate: Date;
    maxDate: Date = new Date();
    minDate: Date = new Date(2000, 0, 1, 0, 0, 0);
    dateMismatch = false;
    selectedIndex: any;
    displayMasterSearch = true;
    userRole: any;
    enableEnrollCustomer: any;
    userSettings: any;
    key: any;
    jobno: any;
    externalkey: any;
    isMulesoftIntegrationEnabled: any;
    searchInputs = { status: '', program: '', contractor: '' };
    isCustomerInfoHidden: boolean = false;
    isDomOrFemd: boolean = false;
    hasMasterFileRecords: boolean = false;
    hasWorkorderMasterFileRecords: boolean = false;
    isSidebarCollapsed: boolean = false;
    isAnySearchInputEntered = false;
    private readonly destroy$ = new Subject<void>();
    private readonly workorderSearchTabs = ['By Workorder', 'By Serial Number', 'By External Key', 'By PSD Job Number'];
    private retainedProgramId: string | null = null;
    private retainedStatusNumber: number | null = null;
    private retainedStatusName: string | null = null;
    private retainedContractorCd: string | null = null;
    private retainedContractorDesc: string | null = null;

    @ViewChild('statusSearchInput') statusSearchInput!: ElementRef<HTMLInputElement>;
    @ViewChild('programSearchInput') programSearchInput!: ElementRef<HTMLInputElement>;
    @ViewChild('customerTableData') customerTableData!: ElementRef<HTMLInputElement>;
    @ViewChild('contractorSearchInput') contractorSearchInput!: ElementRef<HTMLInputElement>;


    @HostListener('document:keydown', ['$event'])
    handleKeyboardEvent(event: KeyboardEvent) {
        this.key = event.key;
        if (event.key !== 'Enter') return;
        if (this.isAnySearchInputEntered) {
            this.doSearch();
            return;
        }
    }

    /**
     * Returns the appropriate Material icon based on the tab label
     * This supports the new sidebar navigation UI
     */
    getTabIcon(label: string): string {
        const iconMap: { [key: string]: string } = {
            'By Phone Number': 'phone',
            'By Address': 'location_on',
            'By Account': 'account_circle',
            'By Email': 'email',
            'By Workorder': 'work',
            'By Serial Number': 'qr_code',
            'By External Key': 'vpn_key',
            'By PSD Job Number': 'assignment',
            'By PremiseId': 'badge',
            'By Check Number': 'receipt_long',
            'By Contractor': 'manage_search'
        };
        return iconMap[label] || 'search';
    }

    constructor(
        private utilityService: UtilityService,
        private dataTransfer: DataTransferService,
        public customerService: CustomerService,
        private router: Router, private locationSearchService: LocationsearchService,
        private dialog: MatDialog, private enrollmentService: EnrollmentService,
        public workorderService: WorkorderService,
        public userService: UserService,
        private spinner: NgxSpinnerService,
        private retainFormDataService: RetainformdataService,
    ) {
        this.addressCriteria = new AddressSearch();

        this.utilityService.utilityMethod$
            .pipe(takeUntil(this.destroy$))
            .subscribe(() => {
                this.doClear();
                this.programList = [];
                this.statusList = [];
                this.loadContractors();
                this.loadWorkorderPrograms();
                this.loadWorkorderStatus();
                if (this.utilityService.currentUtility.OfficeId === "SAN1") {
                    this.displayMasterSearch = false;
                } else {
                    if (this.selectedIndex === 4) {
                        this.displayMasterSearch = false;
                    } else {
                        this.displayMasterSearch = true;
                    }
                }
            });

        this.userService.sharedData$
            .pipe(takeUntil(this.destroy$))
            .subscribe((data: SharedData) => {
                this.isCustomerInfoHidden = data.isCustomerInfoHidden;
                this.isDomOrFemd = data.isCustomUiChange;
            });
    }

    ngOnInit() {
        this.userRole = localStorage.getItem('selectedUtilUserRole');
        console.log('userRole:', this.userRole);

        this.utilityService
            .getSelfScheduleSettings(this.utilityService.currentUtility.OfficeId)
            .subscribe(res => {
                this.userSettings = res;
                this.enableEnrollCustomer = this.userSettings.enableenrollcustomer;
                this.isMulesoftIntegrationEnabled = this.userSettings.MulesoftIntegrationEnabled;
                localStorage.setItem('officeId', this.utilityService.currentUtility.OfficeId);
            });

        this.selectedIndex = 0;

        this.customerService.currentCustomer = null;

        if (this.utilityService.currentUtility.OfficeId === 'SAN1') {
            this.displayMasterSearch = false;
        } else {
            this.displayMasterSearch = ![4, 5, 6, 7, 9].includes(this.selectedIndex);
        }
        const newAccountNumber = localStorage.getItem('newAccountNumber');
        this.dataTransfer.myMethod(false);
        this.loadContractors();
        this.loadWorkorderPrograms();
        this.loadWorkorderStatus();
        const retainedState = this.retainFormDataService.getFormData();
        const isOfficeChanged = this.hasRetainedOfficeChanged(retainedState);
        const isSearchStateRestored = !newAccountNumber && !isOfficeChanged && this.restoreRetainedSearchState();
        if (isOfficeChanged || !isSearchStateRestored) {
            this.doClear();
        }

        if (newAccountNumber) {
            this.accountNumber = newAccountNumber;
            localStorage.removeItem('newAccountNumber');
            this.selectedIndex = 2;
            this.doAccountSearch();
        }
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }

    /**
     * Changes the selected tab and updates the selected index
     * This method prevents the "Expression has changed" error
     */
    changeTab(index: number): void {
        this.doClear();
        this.onInputChange();
        this.selectedIndex = index;
        this.tabChanged({ index: index, tab: null } as MatTabChangeEvent);
    }

    toggleSidebar() {
        this.isSidebarCollapsed = !this.isSidebarCollapsed;
    }

    allowOnlyNumbers(event: KeyboardEvent) {
        const charCode = event.which ? event.which : event.keyCode;
        if (charCode < 48 || charCode > 57) {
            event.preventDefault();
        }
    }

    onDateChange(){
        this.onInputChange();
    }

    onDateInputChange(type:'start' | 'end' ,value: any) {
        if(!value){
            if(type === 'start'){
                this.startDate = null;
            }
            if(type === 'end'){
                this.endDate = null;
            }
        }

        this.onInputChange();
    }


    onInputChange() {
        this.isAnySearchInputEntered = !!(
            this.phoneNumber ||
            this.accountNumber ||
            this.email ||
            this.serialno ||
            this.premiseId ||
            this.jobno ||
            this.externalkey ||
            this.workorderName ||
            this.startDate ||
            this.endDate ||
            this.selectedProgram ||
            this.selectedStatus ||
            this.selectedContractor ||
            this.addressCriteria?.Zipcode ||
            this.addressCriteria?.FirstName ||
            this.addressCriteria?.LastName ||
            this.addressCriteria?.FullName ||
            this.addressCriteria?.StreetAddressNumber ||
            this.addressCriteria?.StreetAddressName ||
            this.addressCriteria?.Zipcode ||
            this.addressCriteria?.Apartment ||
            this.addressCriteria?.City ||
            this.addressCriteria?.State ||
            this.checkNumber
        );
    }

    onDropdownOpen(opened: boolean, type: 'status' | 'program') {
        if (opened) {
            const inputRef =
                type === 'status'
                    ? this.statusSearchInput
                    : this.programSearchInput;
            setTimeout(() => inputRef?.nativeElement?.focus(), 150);
        } else {
            this.searchInputs[type] = '';
        }
    }

    onContractorDropdownOpen(opened: boolean, type: 'contractor') {
        if (opened) {
            const inputRef = this.contractorSearchInput;
            setTimeout(() => inputRef?.nativeElement?.focus(), 150);
        } else {
            this.searchInputs[type] = '';
        }
    }

    getFilteredList(type: 'status' | 'program' | 'contractor') {
        const searchValue = this.searchInputs[type]?.toLowerCase() || '';
        var list: any = (type === 'status') ? this.statusList : this.programList;

        if (type === 'status') list = this.statusList;
        else if (type === 'program') list = this.programList;
        else if (type === 'contractor') list = this.contractors;

         if (type === 'status') {
          return list?.filter(item =>
                (item.JobStatus?.toLowerCase()
                ).includes(searchValue)
            );
         } else if (type === 'program') {
             return list?.filter(item =>
                (item.ProgramName?.toLowerCase()
                ).includes(searchValue)
            );
         } else if (type === 'contractor') {
             return list?.filter(item =>
                (item.OrganizationDesc?.toLowerCase()
                ).includes(searchValue)
            );
         } else {
            return null;
         }

    }


    maskValue(value: string, showChars: number = 4): string {
        if (!value) return '';

        const visible = value.substring(0, showChars);
        return visible + 'XXXX'
    }

    maskName(fullName: string): string {
        if (!fullName) return '';
        const parts = fullName.split(' ');
        if (parts.length === 1) return parts[0] + 'XXXX';

        const firstName = parts[0];
        return `${firstName} XXXX`
    }

    isContractor(): boolean {
        return this.userService.resourceRole?.toLowerCase() === 'contractor' && this.isCustomerInfoHidden;
    }

    /**
     * Opens a dialog to display past participation details.
     * @param row - The external ID containing past participation data.
     */
    openPastParticipationPopup(row: Customer): void {
        this.dialog.open(PastParticipationDialogComponent, {
            data: { row },
            disableClose: true
        });
    }

    sortWOData(sort: Sort) {
        const data = this.workorders;
        if (!sort.active || sort.direction === '') {
            this.dataSource1.data = data;
            return;
        }

        this.dataSource1.data = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'name': return this.compare(a.Name, b.Name, isAsc);
                case 'program': return this.compare(a.Program, b.Program, isAsc);
                case 'status': return this.compare(a.Status, b.Status, isAsc);
                case 'customer': return this.compare(a.Customer, b.Customer, isAsc);
                case 'statusDate': return this.compare(a.StatusDate, b.StatusDate, isAsc);
                case 'address': return this.compare(a.Address, b.Address, isAsc);
                case 'city': return this.compare(a.City, b.City, isAsc);
                case 'serialno': return this.compare(a.SerialNo, b.SerialNo, isAsc);
                case 'externalKey': return this.compare(a.Externalkey, b.Externalkey, isAsc);
                case 'premise': return this.compare(a.PremiseId, b.PremiseId, isAsc);
                case 'externalid': return this.compare(a.ExternalId, b.ExternalId, isAsc);
                case 'checknumber': return this.compare(a.CheckNumber, b.CheckNumber, isAsc);
                default: return 0;
            }
        });
    }

    sortCustData(sort: Sort) {
        const data = this.customers;
        if (!sort.active || sort.direction === '') {
            this.dataSource.data = data;
            return;
        }

        this.dataSource.data = data.sort((a, b) => {
            const isAsc = sort.direction === 'asc';
            switch (sort.active) {
                case 'name': return this.compare(a.Name, b.Name, isAsc);
                case 'account': return this.compare(a.AccountNumber, b.AccountNumber, isAsc);
                case 'phone': return this.compare(a.PrimaryPhone, b.PrimaryPhone, isAsc);
                case 'email': return this.compare(a.Email, b.Email, isAsc);
                case 'serialno': return this.compare(a.SerialNumber, b.SerialNumber, isAsc);
                case 'zip': return this.compare(a.MailingZipcode, b.MailingZipcode, isAsc);
                case 'address': return this.compare(a.MailingStreetAddress1, b.MailingStreetAddress1, isAsc);
                case 'premiseid': return this.compare(a.PremiseId, b.PremiseId, isAsc);
                case 'externalid': return this.compare(a.ExternalId, b.ExternalId, isAsc);
                case 'checknumber': return this.compare(a.checkNumber, b.checkNumber, isAsc);
                default: return 0;
            }
        });
    }

    compare(a: number | string, b: number | string, isAsc: boolean) {
        return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
    }

    tabChanged = (tabChangeEvent: MatTabChangeEvent): void => {
        this.displayResult = false;
        this.displaySerial = false;
        this.displayWorkorder = false;
        this.displayCheckNumber = false;
        this.dataSource.data = [];
        this.dataSource1.data = [];

        const isSanOffice = this.utilityService.currentUtility.OfficeId === 'SAN1';
        const isRestrictedTab = [4, 5, 6, 7, 10].includes(tabChangeEvent.index);

        if (isSanOffice) {
            this.displayMasterSearch = false;
        } else {
            this.displayMasterSearch = !isRestrictedTab;
        }
    };

    ngAfterContentChecked() {
        if (this.utilityService.firstDefaultSet) {
            this.utilityService.firstDefaultSet = false;
            // if (this.utilcode !== null && this.phoneNumber !== null) {
            //     this.doSearch();
            // }
        }
    }


    loadWorkorderPrograms() {
        this.workorderService.getWorkorderPrograms().subscribe(res => {
            if (res !== null) {
                if (Array.isArray(res.Programs)) {
                    this.programList = res.Programs;
                    this.syncRetainedDropdownSelections();
                }
            }
        }, err => {
            console.log(err);
        });
    }

    loadWorkorderStatus() {
        this.workorderService.getWorkorderStatus().subscribe(res => {
            if (res !== null) {
                if (Array.isArray(res.Status)) {
                    this.statusList = res.Status;
                    this.syncRetainedDropdownSelections();
                }
            }
        }, err => {
            console.log(err);
        });
    }

    loadContractors(): void {
        const utility = this.utilityService.currentUtility;

        if (!utility || !utility.OfficeId || !utility.ProgramsponsorId) {
            this.contractors = [];
            this.selectedContractor = null;
            console.warn('Skipping the getContractors call: utility context is not initialized');
            return;
        }

        this.workorderService.getContractors()
            .pipe(takeUntil(this.destroy$))
            .subscribe(res => {
            if (res != null) {
                if (Array.isArray(res.Contractors)) {
                    this.contractors = res.Contractors;
                    this.syncRetainedDropdownSelections();
                }
            }
        }, err => {
            console.log(err);
        });
    }    

    scrollToBuckets(customerData: HTMLElement) {
        if (!customerData) return;
        customerData.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }


    // New implementation uses tab label instead of index to determine the search method.
    public doSearch() {
        this.spinner.show();
        const currentLabel: string = this.tabConfig[this.selectedIndex].label;
        if (!currentLabel) {
            this.spinner.hide();
            return;
        }
        this.doSearchByLabel(currentLabel);
    }

    tabConfig = [
        { label: 'By Phone Number', method: () => this.doPhoneSearch() },
        { label: 'By Address', method: () => this.doAddressSearch() },
        { label: 'By Account', method: () => this.doAccountSearch() },
        { label: 'By Email', method: () => this.doEmailSearch() },
        { label: 'By Workorder', method: () => this.doWorkorderSearch() },
        { label: 'By Serial Number', method: () => this.doSerialnoSearch() },
        { label: 'By External Key', method: () => this.doExternalKeySearch() },
        { label: 'By PSD Job Number', method: () => this.doPSDJobnoSearch() },
        { label: 'By PremiseId', method: () => this.doPremiseIdSearch() },
        { label: 'By Check Number', method: () => this.doCheckNumberSearch() },
        { label: 'By Contractor', method: () => this.doContractorSearch()}
    ]

    public doSearchByLabel(label: string) {
        const tab = this.tabConfig?.find(t =>
            t.label.toLocaleLowerCase() === label.toLocaleLowerCase());
        if (tab && tab.method) {
            tab.method();
        } else {
            console.log(`No Search method found for label: ${label}`);
        }
    }

    goBack() {
        this.displaySearch = true;
        this.displayResult = false;
        this.displayWorkorder = false;
        this.displaySerial = false;
        this.displayCheckNumber = false;
    }

    private isWorkorderResultTab(index: number): boolean {
        const currentTabLabel = this.tabConfig[index]?.label;
        return this.workorderSearchTabs.includes(currentTabLabel);
    }

    private saveRetainedSearchState(): void {
        this.retainFormDataService.setFormData({
            officeId: this.utilityService.currentUtility?.OfficeId ?? null,
            selectedIndex: this.selectedIndex,
            isSidebarCollapsed: this.isSidebarCollapsed,
            displayResult: this.displayResult,
            displayWorkorder: this.displayWorkorder,
            displaySerial: this.displaySerial,
            displayCheckNumber: this.displayCheckNumber,
            phoneNumber: this.phoneNumber,
            accountNumber: this.accountNumber,
            email: this.email,
            premiseId: this.premiseId,
            checkNumber: this.checkNumber,
            serialno: this.serialno,
            jobno: this.jobno,
            externalkey: this.externalkey,
            workorderName: this.workorderName,
            selectedProgram: this.selectedProgram,
            selectedStatus: this.selectedStatus,
            selectedContractor: this.selectedContractor,
            selectedProgramId: this.selectedProgram?.ProgramId ?? null,
            selectedStatusNumber: this.selectedStatus?.JobStatusNumber ?? null,
            selectedStatusName: this.selectedStatus?.JobStatus ?? null,
            selectedContractorCd: this.selectedContractor?.OrganizationCd ?? null,
            selectedContractorDesc: this.selectedContractor?.OrganizationDesc ?? null,
            startDate: this.startDate ? new Date(this.startDate).toISOString() : null,
            endDate: this.endDate ? new Date(this.endDate).toISOString() : null,
            addressCriteria: { ...this.addressCriteria },
            customers: this.customers || [],
            workorders: this.workorders || []
        });
    }

    private hasRetainedOfficeChanged(state: any): boolean {
        if (!state) {
            return false;
        }

        const currentOfficeId = this.utilityService.currentUtility?.OfficeId ?? null;
        const retainedOfficeId = state.officeId ?? null;
        return !!retainedOfficeId && retainedOfficeId !== currentOfficeId;
    }

    private syncRetainedDropdownSelections(): void {
        if (this.retainedProgramId && Array.isArray(this.programList)) {
            const matchedProgram = this.programList.find(p => p?.ProgramId === this.retainedProgramId);
            if (matchedProgram) {
                this.selectedProgram = matchedProgram;
            }
        }

        if ((this.retainedStatusNumber !== null || this.retainedStatusName) && Array.isArray(this.statusList)) {
            const matchedStatus = this.statusList.find(s =>
                (this.retainedStatusNumber !== null && s?.JobStatusNumber === this.retainedStatusNumber)
                || (!!this.retainedStatusName && s?.JobStatus === this.retainedStatusName)
            );
            if (matchedStatus) {
                this.selectedStatus = matchedStatus;
            }
        }

        if ((this.retainedContractorCd || this.retainedContractorDesc) && Array.isArray(this.contractors)) {
            const matchedContractor = this.contractors.find(contractor =>
                (this.retainedContractorCd && contractor?.OrganizationCd === this.retainedContractorCd)
                || (!!this.retainedContractorDesc && contractor?.OrganizationDesc === this.retainedContractorDesc)
            );
            if (matchedContractor) {
                this.selectedContractor = matchedContractor;
            }
        }
    }

    private restoreRetainedSearchState(): boolean {
        const state = this.retainFormDataService.getFormData();
        if (!state) {
            return false;
        }

        this.selectedIndex = Number(state.selectedIndex ?? this.selectedIndex ?? 0);
        this.isSidebarCollapsed = !!state.isSidebarCollapsed;
        this.displayResult = !!state.displayResult;
        this.displayWorkorder = !!state.displayWorkorder;
        this.displaySerial = !!state.displaySerial;
        this.displayCheckNumber = !!state.displayCheckNumber;
        this.phoneNumber = state.phoneNumber ?? '';
        this.accountNumber = state.accountNumber ?? '';
        this.email = state.email ?? '';
        this.premiseId = state.premiseId ?? '';
        this.checkNumber = state.checkNumber ?? '';
        this.serialno = state.serialno ?? '';
        this.jobno = state.jobno ?? '';
        this.externalkey = state.externalkey ?? '';
        this.workorderName = state.workorderName ?? '';
        this.selectedProgram = state.selectedProgram ?? null;
        this.selectedStatus = state.selectedStatus ?? null;
        this.selectedContractor = state.selectedContractor ?? null;
        this.retainedProgramId = state.selectedProgramId ?? state.selectedProgram?.ProgramId ?? null;
        this.retainedStatusNumber = state.selectedStatusNumber ?? state.selectedStatus?.JobStatusNumber ?? null;
        this.retainedStatusName = state.selectedStatusName ?? state.selectedStatus?.JobStatus ?? null;
        this.retainedContractorCd = state.selectedContractorCd ?? state.selectedContractor?.OrganizationCd ?? null;
        this.retainedContractorDesc = state.selectedContractorDesc ?? state.selectedContractor?.OrganizationDesc ?? null;
        this.startDate = state.startDate ? new Date(state.startDate) : undefined;
        this.endDate = state.endDate ? new Date(state.endDate) : undefined;
        this.addressCriteria = {
            ...new AddressSearch(),
            ...(state.addressCriteria || {})
        };

        this.customers = Array.isArray(state.customers) ? state.customers : [];
        this.workorders = Array.isArray(state.workorders) ? state.workorders : [];
        this.dataSource.data = this.customers;
        this.dataSource1.data = this.workorders;
        this.searching = false;
        this.workorderSearching = false;
        this.syncRetainedDropdownSelections();
        this.onInputChange();

        return true;
    }

    private clearRetainedSearchState(): void {
        this.retainFormDataService.setFormData(null);
    }

    private doWorkorderSearch() {
        this.dateMismatch = false;
        this.workorders = [];

        if (!this.workorderName &&
            !this.selectedProgram &&
            !this.selectedStatus &&
            !this.startDate &&
            !this.endDate) {
            this.noDataEntered = true;
            return;
        }
        this.noDataEntered = false;
        let start: Date;
        let end: Date;

        if (!this.startDate && !this.endDate) {
            start = new Date(2000, 0, 1, 0, 0, 0);
            end = null;

        } else if (this.startDate && !this.endDate) {
            start = this.startDate;
            end = new Date();
            end.setDate(end.getDate() + 1);
            end.setHours(23, 59, 59);

        } else if (!this.startDate && this.endDate) {
            start = new Date(2000, 0, 1, 0, 0, 0);
            end = this.endDate;
            end.setDate(end.getDate() + 1);
            end.setHours(23, 59, 59);

        } else {
            if (this.startDate <= this.endDate) {
                start = this.startDate;
                end = this.endDate;
                end.setDate(end.getDate() + 1);
                end.setHours(23, 59, 59);
            } else {
                this.dateMismatch = true;
                return;
            }
        }

        this.displayWorkorder = true;
        this.displaySerial = false;
        this.displayResult = false;
        this.displayCheckNumber = false;
        this.workorderSearching = true;

        this.workorderName = this.workorderName ?? '';
        const programId = this.selectedProgram?.ProgramId ?? '';

        this.statusData =
            this.utilityService.currentUtility.Source === 'BBCS'
                ? this.selectedStatus?.JobStatusNumber ?? '-1'
                : this.selectedStatus?.JobStatus ?? '';

        this.customerService
            .workorderSearch(this.workorderName, programId, this.statusData, start, end)
            .subscribe({
                next: (res: any[]) => {
                    if (res && res.length > 0) {
                        this.endWorkorderSearch(res);
                    } else {
                        this.workorders = [];
                        this.dataSource1.data = [];
                        this.workorderSearching = false;
                        this.spinner.hide();
                        this.saveRetainedSearchState();
                    }
                },
                error: () => {
                    this.workorderSearching = false;
                    this.spinner.hide();
                }
            });
    }


    private doPhoneSearch() {
        this.displaySearch = false;
        this.displayResult = true;
        this.displayWorkorder = false;
        this.displaySerial = false;
        this.displayCheckNumber = false;
        this.searching = true;
        this.customers = [];
        this.customerService.getCustomerByPhone(this.phoneNumber).subscribe((data: Customer[]) => {
            this.endSearch(data);
        }, err => {
            this.searching = false;
        });
    }

    private doEmailSearch() {
        this.displaySearch = false;
        this.displayResult = true;
        this.displayWorkorder = false;
        this.displaySerial = false;
        this.displayCheckNumber = false;
        this.searching = true;
        this.customers = [];
        this.customerService.getCustomerByEmail(this.email).subscribe((data: Customer[]) => {
            this.endSearch(data);
        }, err => {
            this.searching = false;
        });
    }

    private doSerialnoSearch() {
        this.dateMismatch = false;
        this.displaySerial = true;
        this.displayWorkorder = false;
        this.workorderSearching = true;
        this.displayCheckNumber = false;
        this.workorders = [];
        this.customerService.getCustomerBySerialno(this.serialno).subscribe((res: []) => {

            console.log("serialno results:", res);

            if (res !== null || res.length > 0) {
                this.endWorkorderSearch(res);
            }

        }, err => {
            this.workorderSearching = false;
        })

    }

    private doPSDJobnoSearch() {
        this.dateMismatch = false;
        this.displaySerial = true;
        this.displayWorkorder = false;
        this.displayCheckNumber = false;
        this.workorderSearching = true;
        this.workorders = [];
        this.customerService.getCustomerByPSDJobId(this.jobno).subscribe((res: []) => {

            console.log("jobno results:", res);

            if (res !== null || res.length > 0) {
                this.endWorkorderSearch(res);
            }

        }, err => {
            this.workorderSearching = false;
        })

    }

        private doContractorSearch() {
        this.displayWorkorder = true;
        this.displaySerial = false;
        this.displayResult = false;
        this.workorderSearching = true;
        this.workorders = [];
        
        if (this.selectedContractor != null) {
            this.customerService.getCustomerByContractor(this.selectedContractor.OrganizationCd).subscribe((res: []) => {
                if (res !== null || res.length > 0) {
                    this.endWorkorderSearch(res);
                }
            }, err => {
                this.workorderSearching = false;
            });
        }
    }    

    private doExternalKeySearch() {
        this.dateMismatch = false;
        this.displaySerial = true;
        this.displayWorkorder = false;
        this.displayCheckNumber = false;
        this.workorderSearching = true;
        this.workorders = [];
        this.customerService.getWorkorderByExternalKey(this.externalkey).subscribe((res: []) => {

            console.log("externalkey results:", res);

            if (res !== null || res.length > 0) {
                this.endWorkorderSearch(res);
            }

        }, err => {
            this.workorderSearching = false;
        })
    }

    private doAddressSearch() {
        this.displayResult = true;
        this.searching = true;
        this.displayWorkorder = false;
        this.displaySerial = false;
        this.displayCheckNumber = false;
        this.customers = [];
        this.customerService.getCustomerByAddress(this.addressCriteria, this.isMulesoftIntegrationEnabled).subscribe((data: Customer[]) => {
            this.endSearch(data)
        },
            err => {
                this.searching = false;
            });
    }

    private doAccountSearch() {
        this.displayWorkorder = false;
        this.displaySerial = false;
        this.displayResult = true;
        this.displayCheckNumber = false;
        this.searching = true;
        this.customers = [];

        //Integrated with PSEG for search
        this.customerService.getCustomerByAccountNo(this.accountNumber, this.isMulesoftIntegrationEnabled).subscribe((data: Customer[]) => {
            this.endSearch(data);
        }, err => {
            this.searching = false;
        });
    }

    /** search premiseId */
    private doPremiseIdSearch() {
        this.displayWorkorder = false;
        this.displaySerial = false;
        this.displayResult = true;
        this.displayCheckNumber = false;
        this.searching = true;
        this.customers = [];
        this.customerService.getCustomerBypremiseId(this.premiseId, this.isMulesoftIntegrationEnabled).subscribe((data: Customer[]) => {
            this.endSearch(data);
        }, err => {
            this.searching = false;
        });
    }

    private doCheckNumberSearch() {
    this.displayResult = false;
    this.displayWorkorder = false;
    this.displaySerial = false;
    this.displayCheckNumber = true;
    
    this.searching = true;
    this.customers = [];   // <-- Add this
    
    //localStorage.setItem('checkNumber', this.checkNumber);
    
    this.customerService
        .getCustomerBycheckNumber(this.checkNumber, this.isMulesoftIntegrationEnabled)
        .subscribe((data: any[]) => {
    
        console.log("API Response", data);
        this.customers = data;          
        this.dataSource.data = data;
        this.searching = false;
        this.spinner.hide();
        this.saveRetainedSearchState();
        setTimeout(() => {
            this.scrollToBuckets(this.customerTableData.nativeElement);
        }, 200);
    
        }, err => {
        this.searching = false;
        this.spinner.hide();
        });
  }

    endWorkorderSearch(workorder) {
        this.workorders = [];
        for (let i = 0; i < workorder.length; i++) {
            const c = new Workorder();
            c.setFromWeb(workorder[i]);
            this.workorders.push(c);
        }

        this.dataSource1.data = this.workorders;
        console.log(this.workorders);
        this.workorderSearching = false;
        this.hasWorkorderMasterFileRecords = this.workorders.some(w => w.FromMaster === true);
        this.spinner.hide();
        this.saveRetainedSearchState();

        setTimeout(() => {
            this.scrollToBuckets(this.customerTableData.nativeElement);
        }, 200);
    }

    endSearch(cust) {
        this.customers = [];
        for (let i = 0; i < cust.length; i++) {
            const c = new Customer();
            c.setUpFromWS(cust[i]);
            this.customers.push(c);
        }
        this.dataSource.data = this.customers;
        this.searching = false;
        this.hasMasterFileRecords = this.customers.some(c => c.FromMaster === true);
        this.spinner.hide();
        this.saveRetainedSearchState();

        setTimeout(() => {
            this.scrollToBuckets(this.customerTableData.nativeElement);
        }, 200);
    }

    navigateToBucketSchedule(workorder) {
        if (this.isWorkorderResultTab(this.selectedIndex)) {
            this.saveRetainedSearchState();
        }
        this.router.navigate(['bucketSchedule', workorder.Id]);
    }

    navigateToSchedule(workorder) {
        if (this.isWorkorderResultTab(this.selectedIndex)) {
            this.saveRetainedSearchState();
        }
        this.workorderService.currentWorkorderID = workorder.Id;
        this.workorderService.currentWorkorder = workorder;
        this.locationSearchService.grid = null;
        this.locationSearchService.personcompany = null;
        this.locationSearchService.scheduledate = null;
        this.locationSearchService.schdate = null;
        this.locationSearchService.workorderID = null;
        if (workorder.StatusNumber == 190) {
            this.workorderService.workorderStatusCode = 'schedule'
            this.router.navigate(['scheduling', workorder.Group, workorder.SubGroup, workorder.Id, 'schedule'])
        } else if (workorder.StatusNumber == 200) {
            this.workorderService.workorderStatusCode = 'reschedule'
            this.router.navigate(['scheduling', workorder.Group, workorder.SubGroup, workorder.Id, 'reschedule'])
        }

        // const action =
        //     workorder?.StatusNumber === 190 ?
        //         'schedule' : workorder?.StatusNumber === 200 ?
        //             'reschedule' : null;

        // if (action) {
        //     this.workorderService.workorderStatusCode = action;
        //     this.router.navigate([
        //         'scheduling',
        //         workorder.Group,
        //         workorder.SubGroup,
        //         workorder.Id,
        //         action
        //     ]);
        // }

    }

    handleWorkorderClick(workorder: Workorder) {
        this.dataTransfer.myMethod(true);
        if (this.utilityService.currentProgramSponsor.SourceId === 'BBCS') {
            this.navToWorkorderDetail(workorder);
        } else {
            this.workorderService.getWorkorderDetailsByWorkorderId(workorder.Id, workorder.CustomerId).subscribe(detailWorkorder => {

                if (!detailWorkorder) {
                    return this.handleError('Failed to retrieve workorder');
                }
                this.navToWorkorderDetail(detailWorkorder);
            });
        }
    }

    handleClick(cust: Customer) {
        let className = localStorage.getItem("themeName");
        this.dataTransfer.myMethod(true);

        if (cust.FromMaster) {
            const dialogRef = this.dialog.open(WaitDialogComponent,
                {
                    data: {
                        caption: 'Wait while master file record is saved as Customer'
                    },
                    panelClass: className
                }
            );

            this.customerService.createCustomer(cust)
                .subscribe(
                    data => {
                        if (data?.success) {
                            this.customerService.getCustomerById(data.id).subscribe(newCust => {
                                if (!newCust) {
                                    dialogRef.close();
                                    this.handleError('Failed to retrieve new customer');
                                } else {
                                    dialogRef.close();
                                    this.navToDetail(newCust);
                                }
                            });
                        } else {
                            dialogRef.close();
                            this.handleError(data.errors);
                        }
                    },
                    err => {
                        dialogRef.close();
                        this.handleError(err);
                    }
                );
        } else {
            this.customerService.getCustomerById(cust.Id).subscribe(detailCust => {
                if (!detailCust) {
                    this.handleError('Failed to retrieve customer');
                } else {
                    this.navToDetail(detailCust);
                }
            });
        }
    }

    navToDetail(cust: any) {
        if (this.isWorkorderResultTab(this.selectedIndex)) {
            this.saveRetainedSearchState();
        }
        const tempcust: Customer = new Customer();
        tempcust.setUpFromWS(cust);
        this.customerService.currentCustomer = tempcust;
        this.customerService.storedCustomers(tempcust);
        this.router.navigate(['/detail']);
    }

    navToWorkorderDetail(workorder: any) {
        if (this.isWorkorderResultTab(this.selectedIndex)) {
            this.saveRetainedSearchState();
        }
        const tempWorkorder: Workorder = new Workorder();
        tempWorkorder.isWorkorder = true;
        if (this.utilityService.currentProgramSponsor.SourceId === 'BBCS') {
            this.workorderService.currentWorkorderID = workorder.Id;
            this.enrollmentService.currentEnrollmentID = workorder.EnrollmentId;
            tempWorkorder.Name = workorder.Name;
            workorder.ProgramSponsorId = this.utilityService.currentProgramSponsor.ProgramSponsorId;
            tempWorkorder.setFromWeb(workorder);
            this.workorderService.currentWorkorder = tempWorkorder;
            this.customerService.storedCustomers(tempWorkorder);
            if (workorder.Group == null) {
                workorder.Group = 'DEFAULT';
            }
            this.router.navigate(['workorderGetSave', workorder.Group, workorder.SubGroup, workorder.Id, workorder?.SubGroup1 ?? "ALL"])
        } else {
            tempWorkorder.Name = workorder.WorkorderName;
            tempWorkorder.setFromWeb(workorder);
            this.workorderService.currentWorkorder = tempWorkorder;
            this.customerService.storedCustomers(tempWorkorder);
            this.router.navigate(['/workorderDetail']);
        }
    }

    doClear() {
        this.clearRetainedSearchState();
        this.phoneNumber = "";
        this.accountNumber = "";
        this.email = '';
        this.premiseId = '';
        this.checkNumber = '';
        this.serialno = '';
        this.jobno = '';
        this.externalkey = '';
        this.addressCriteria.FirstName = "";
        this.addressCriteria.LastName = "";
        this.addressCriteria.FullName = "";
        this.addressCriteria.Apartment = "";
        this.addressCriteria.City = "";
        this.addressCriteria.State = "";
        this.addressCriteria.StreetAddressName = "";
        this.addressCriteria.StreetAddressNumber = "";
        this.addressCriteria.Zipcode = "";
        this.workorderName = "";
        this.selectedProgram = null;
        this.selectedStatus = null;
        this.selectedContractor = null;
        this.retainedProgramId = null;
        this.retainedStatusNumber = null;
        this.retainedStatusName = null;
        this.retainedContractorCd = null;
        this.retainedContractorDesc = null;
        this.startDate = undefined;
        this.endDate = undefined;
        this.displayResult = false;
        this.displayWorkorder = false;
        this.displaySerial = false;
        this.displayCheckNumber = false;
        this.customers = [];
        this.workorders = [];
        this.dataSource.data = [];
        this.dataSource1.data = [];
        this.onInputChange();
    }

    handleError(mesg: string) {
        Swal.fire({
            title: 'Error',
            text: mesg,
            icon: 'error',
            confirmButtonText: 'OK',
        })
    }

    navigateToEnrollmentForm(): void {
        this.router.navigate(['enrollcustomer']);
    } 
}

export class Programs {
    ProgramName: string = '';
    ProgramId: string = '';
}

export class Status {
    JobStatusNumber: number = 0;
    JobStatus: string = '';
}

export class Contractors {
    OrganizationCd: string = '';
    OrganizationDesc: string = '';
}

